import Operation from './Operation.js';
import SplitPianoRollPattern from './SplitPianoRollPattern.js';
import DeleteSelection from './DeleteSelection.js';
import InsertRollEvent from './InsertRollEvent.js';
import InsertEvent from './InsertEvent.js';
import {
    constructEvent,
    NO_SUB_SEQUENCE,
    SEQUENCE_ROLL} from 'session/constants.js';

const DETERMINISTIC = 'DETERMINISTIC';
const LINEAR = 'LINEAR';
const BASIC = 'BASIC';

class GenericSelection extends Operation {
    constructor(mix, step, selection, mixType) {
        super(mix, undefined);

        this.step = step;
        this.selection = selection;
        this.start = this.selection.start;
        this.end = this.selection.end;
        this.mixType = mixType;
    }

    execute() {
        if (this.mix.subSequence.id === NO_SUB_SEQUENCE.id) {
            // then we only do sequence roll
            this.mixType = SEQUENCE_ROLL;
        }

        if (this.mixType !== undefined) {
            // just execute for this specific type then
            if (this.mix.mixesByType[this.mixType]) {
                this.executeByType(this.mixType, this.mix.mixesByType[this.mixType]);
            } else if (this.mix.deterministicMixesByType[this.mixType]) {
                this.executeByType(this.mixType, this.mix.deterministicMixesByType[this.mixType]);
            }
            return;
        }

        // otherwise execute for every type in this mix
        for (let type in this.mix.mixesByType) {
            let mixByType = this.mix.mixesByType[type];
            this.executeByType(parseInt(type), mixByType);
        }

        for (let type in this.mix.deterministicMixesByType) {
            let mixByType = this.mix.deterministicMixesByType[type];
            this.executeByType(parseInt(type), mixByType);
        }

        if (this.mix.subSequence.isTrack) {
            this.executeForTrack(this.mix.subSequence.tracks[0]);
        }
    }

    executeByType(eventType, mixByType, mixType) {
    }

    executeForTrack() {}

    splitIntersectingPatterns(track) {
        let overlappingStart = track.patterns.find(
            pattern => pattern.overlapsStep(this.start) && pattern.startStep < this.start);
        this.splitPattern(overlappingStart, this.start);

        let overlappingEnd = track.patterns.find(
            pattern => pattern.overlapsStep(this.end) && pattern.startStep < this.end);

        this.splitPattern(overlappingEnd, this.end);
    }

    splitPattern(pattern, step) {
        if (pattern === undefined) {
            return;
        }

        new SplitPianoRollPattern(pattern.track, pattern, step)
            .execute();
    }
}

export default GenericSelection;
